// navData.js
export const NAV_LINKS = [
  { label: "Home", href: "/" },
  {
    label: "Services",
    href: "/services",
    description: "Holistic marketing solutions tailored for maximum impact.",
    hasDropdown: true,
    subLinks: [
      { name: "Brand Strategy & Campaign Planning", href: "/services/brand-strategy-campaign-planning" },
      { name: "Event Management & On-ground Activations", href: "/services/event-management-on-ground-activations" },
      { name: "Social Media Management", href: "/services/social-media-management" },
      { name: "PR & Media Coverage", href: "/services/pr-media-coverage" },
      { name: "Corporate & Promotional Videos", href: "/services/corporate-promotional-videos" },
      { name: "Print, Design & Brand Identity", href: "/services/print-design-brand-identity" },
      { name: "Website Design & Web Development", href: "/services/website-design-web-development" },
      { name: "Software Development", href: "/services/software-development" },
    ],
  },
  {
    label: "Portfolio",
    href: "/portfolio",
    description: "Showcase of our award-winning work across the globe.",
  },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];
